var map = {
	"./EMC-logo.png": "52b0",
	"./ERP-logo.png": "bfa5",
	"./LFGB-logo.png": "0087",
	"./LVD-logo.png": "16d0",
	"./Recycler2.png": "ee36",
	"./apple-logo.png": "73f9",
	"./battery-replacement.png": "ef95",
	"./battery-status.png": "bd51",
	"./code-of-conduct.png": "2c1f",
	"./crosshair.png": "8450",
	"./dhl-logo.png": "efa2",
	"./dustin-logo.png": "3b21",
	"./e-star-logo.png": "7c11",
	"./elgiganten-logo.png": "a4fd",
	"./elkretsen-logo.png": "d68d",
	"./follow-up.png": "160b",
	"./fonts/KeepIconRegular.woff": "e77b",
	"./fonts/KeepIconRegular.woff2": "62ce",
	"./gbg-logo.png": "f604",
	"./global.css": "150b",
	"./highpower-logo.png": "ada3",
	"./hunan-logo.png": "c55e",
	"./icons/down.svg": "d8aa",
	"./icons/forward.svg": "bdb1",
	"./illustrations/onboarding/Certifier1.png": "c67d",
	"./illustrations/onboarding/Certifier2.png": "d8ab",
	"./illustrations/onboarding/Producer1.png": "107f",
	"./illustrations/onboarding/Producer2.png": "ddca",
	"./illustrations/onboarding/Producer3.png": "b61d",
	"./illustrations/onboarding/Producer4.png": "6f98",
	"./illustrations/onboarding/Recycler1.png": "1ce0",
	"./illustrations/onboarding/Recycler2.png": "a349",
	"./illustrations/onboarding/Remanufacturing1.png": "4f4f",
	"./illustrations/onboarding/Service1_Remanufacturing2.png": "dcab",
	"./illustrations/onboarding/Service2.png": "0b78",
	"./illustrations/onboarding/Users1.png": "8f93",
	"./illustrations/onboarding/Users2.png": "419b",
	"./illustrations/onboarding/Users3.png": "089c",
	"./illustrations/onboarding/Users4.png": "4403",
	"./illustrations/producer1.png": "0cc6",
	"./illustrations/producer2.png": "120d",
	"./illustrations/remanufacturer1.png": "3f5a",
	"./keep-logo-inverted.png": "edfc",
	"./keep-logo.png": "f3ae",
	"./keyboard-replacement.png": "386f",
	"./lenovo-laptop.png": "b8d7",
	"./lenovo-logo.png": "ad7b",
	"./lenovo-manual.png": "4f20",
	"./lenovo-services-logo.png": "0e62",
	"./logo.png": "cf05",
	"./logos/Blippa_icon.png": "a2fd",
	"./logos/ChalmersIndustriteknik.png": "07a3",
	"./logos/CircularHub.png": "47c6",
	"./logos/ClasOhlson.png": "b5bc",
	"./logos/Dustin.png": "f386",
	"./logos/ElKretsen.png": "5711",
	"./logos/GIAB.png": "a631",
	"./logos/GS1.png": "487a",
	"./logos/Lenovo.png": "3e31",
	"./logos/Mirec.png": "ff36",
	"./logos/Naturskyddsforeningen.png": "3c80",
	"./logos/Recipo.png": "35c3",
	"./logos/Scandi.png": "9ae8",
	"./logos/Stena.png": "cb5c",
	"./logos/TCO.png": "9c61",
	"./logos/TechBuddy.png": "44e2",
	"./logos/TheCircularityHub.png": "b042",
	"./logos/Trace_4_value.png": "44c1",
	"./logos/WEEE_symbol.png": "5f36",
	"./logos/boid_logo.png": "e2f8",
	"./logos/boid_logo_new.png": "2fab",
	"./logos/circla-white.png": "9fc1",
	"./logos/circla_logo.png": "db3c",
	"./logos/clasohlson_logo.png": "4164",
	"./logos/github-mark.svg": "49fa",
	"./logos/keepLogo.png": "62b8",
	"./logos/logo_icon_Blippa.png": "a65e",
	"./logos/logo_manufacturer.png": "1fc3",
	"./logos/logo_voxicon.png": "39a1",
	"./logos/norsirk-logo.png": "544e",
	"./logos/trace4value_logo.png": "aa1e",
	"./map.png": "8b55",
	"./newlogos/Kezzler.png": "9531",
	"./newlogos/ascdi-logotype.png": "1573",
	"./newlogos/blippa-logo.png": "187a",
	"./newlogos/chaintraced-logo.png": "71cf",
	"./newlogos/circularise-logo.png": "1842",
	"./newlogos/clasohlson-logo.png": "32b4",
	"./newlogos/dustin-logo.png": "faac",
	"./newlogos/elkretsen-logo.png": "598d",
	"./newlogos/foxway-logo.png": "ebfd",
	"./newlogos/giab-logo.png": "84b6",
	"./newlogos/gs1-logo.png": "c67db",
	"./newlogos/lenovo-logo.png": "1e63",
	"./newlogos/mousetrapper-logo.png": "3e3f",
	"./newlogos/norsirk-logo.png": "8716",
	"./newlogos/scandi-logo.png": "40af",
	"./newlogos/smithereens-logo.png": "3a0e",
	"./newlogos/tco-logo.png": "a385",
	"./newlogos/techbuddy-logo.png": "98f0",
	"./newlogos/telia-logo.png": "4489",
	"./newlogos/transparent-logo.png": "7ad3",
	"./newlogos/twist-logo.png": "f5c9",
	"./parts/battery-icon.png": "4cfe",
	"./parts/camera.png": "c735",
	"./parts/control-panel.png": "4b19",
	"./parts/cpu-icon.png": "3ded",
	"./parts/display-icon.png": "d666",
	"./parts/glass-jug.png": "da51",
	"./parts/gpu-icon.png": "b560",
	"./parts/power-cord.png": "988f",
	"./parts/value-icon.png": "0b48",
	"./postalService.png": "dd39",
	"./products/CO443726(3).png": "c90d",
	"./products/CO443726.png": "f4df",
	"./products/LightSpeaker.png": "213e",
	"./products/LightSpeakerWhite.png": "6d30",
	"./products/iphone.jpeg": "2389",
	"./products/keepLaptop.png": "dd76",
	"./products/laptop.png": "9b9b",
	"./products/lenovo-laptop.png": "92e4",
	"./products/lenovo_x1yoga.png": "5af7",
	"./products/voxicon-d27qo.jpg": "ecdf",
	"./products/voxicon-d27qo.png": "845d",
	"./rba-member.png": "117f",
	"./reach-logo.png": "e44b",
	"./resell-giab.png": "49de",
	"./resell-inrego.png": "d4b9",
	"./rohs-logo.png": "467e",
	"./roles/certifier.svg": "e940",
	"./roles/consumer.svg": "4c47",
	"./roles/producer.svg": "3ccd",
	"./roles/recycler.svg": "dc66",
	"./roles/remanufacturer.png": "690d",
	"./roles/remanufacturer.svg": "2015",
	"./roles/service.svg": "44de",
	"./security-status.png": "06b8",
	"./smile-1.png": "d328",
	"./smile-2.png": "78a8",
	"./smile-3.png": "e69e",
	"./smile-4.png": "2762",
	"./smile-5.png": "5a52",
	"./smileys/smiley_1.svg": "cb25",
	"./smileys/smiley_2.svg": "5c4d",
	"./smileys/smiley_3.svg": "6422",
	"./smileys/smiley_4.svg": "49c0",
	"./smileys/smiley_5.svg": "e592",
	"./suppliers/ktc.png": "87db",
	"./suppliers/random-logo.png": "85d2",
	"./tco-logo.png": "a158",
	"./techbuddy-logo.png": "840c",
	"./temp-status.png": "802a",
	"./timeline.svg": "f823",
	"./transparent/CCC.png": "1e40",
	"./transparent/CE.png": "1dea",
	"./transparent/EAC.png": "ac63",
	"./transparent/FCC.png": "d6c7",
	"./transparent/ILO.png": "cc71",
	"./transparent/ISO14001.png": "b827",
	"./transparent/ISO45001.png": "8c87",
	"./transparent/KC.png": "3ad3",
	"./transparent/PSE.png": "9471",
	"./transparent/RCM.png": "82cf",
	"./transparent/SMETA.png": "4a63",
	"./transparent/SafetyMark.png": "ea4b",
	"./transparent/TS.png": "5128",
	"./transparent/TUV.png": "650c",
	"./transparent/UKCA.png": "92cf",
	"./transparent/UNGlobalCompact.png": "eb56",
	"./transparent/WEEE.png": "be20",
	"./transparent/transparent-logo.png": "2622",
	"./troubleshoot.png": "0767",
	"./tullverket-logo.png": "eab8",
	"./vinnova.png": "b943",
	"./weee-logo.png": "4591"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";